export class CloudResourceAttachmentEvent {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "date",
            "baseName": "date",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "policyId",
            "baseName": "policyId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "eventType",
            "baseName": "eventType",
            "type": "CloudResourceAttachmentEventType",
            "format": ""
        },
        {
            "name": "reason",
            "baseName": "reason",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudResourceAttachmentEvent.attributeTypeMap;
    }
    constructor() {
    }
}
